import { useClaims } from '@lmt/unicorn-shared/app/features/auth/operations';
import React, { FC } from 'react';
import { useUniSelector } from '@lmt/unicorn-shared/app/store/types';

export interface Props {
  children?: React.ReactNode;
}

export const DeveloperMode: FC<Props> = (props) => {
  const claims = useClaims();

  return <>{claims.permissions.developerMode && props.children}</>;
};
